/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-20 10:23:41
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 15:20:53
 * @FilePath: /chaoyongtuan/src/modules/commander/commander.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { institutionList } from '@/api/teamManage';

export const getCommanderList = async (showAll, platformId, showTime = false) => {
	return new Promise(async resolve => {
		let params = {
			sync: showTime ? 1 : 0,
			type: showAll ? 1 : 0,
			platformId,
		};
		let { data, code } = await institutionList(params);
		if (code !== 0) return;
		resolve(data);
	});
};

export default { getCommanderList };
